<script lang="ts" setup>
import { useWidgetStore } from './stores/widget-store'

const route = useRoute()
const widgetStore = useWidgetStore()

if (route.query?.authToken && typeof route.query.authToken === 'string')
  widgetStore.setAuthToken(route.query.authToken)

if (route.query?.orgId && typeof route.query.orgId === 'string')
  widgetStore.setOrgId(route.query.orgId)

if (route.query?.returnUrl && typeof route.query.returnUrl === 'string')
  widgetStore.setReturnUrl(route.query.returnUrl)

const canvas = ref(null)

const isRoundRectSupporting = ref(false)

onMounted(() => {
  try {
    const ctx = canvas.value.getContext('2d')
    ctx.strokeStyle = 'red'
    ctx.beginPath()
    ctx.roundRect(10, 20, 150, 100, 0)
    ctx.stroke()
    isRoundRectSupporting.value = true
  } catch (error) {
    alert(
      'Версия вашего браузера не поддерживается. Пожалуйста, обновите версию браузера до последней'
    )
  }

  

  {
    ;(function (m, e, t, r, i, k, a) {
      m[i] =
        m[i] ||
        function () {
          ;(m[i].a = m[i].a || []).push(arguments)
        }
      m[i].l = 1 * new Date()
      for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
          return
        }
      }
      ;(k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a)
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

    ym(95432634, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
      ecommerce: 'dataLayer'
    })
  }
})
</script>

<template>
  <div>
    <canvas class="h-0 w-0 max-h-0 max-w-0" ref="canvas"></canvas>
    <NuxtPage v-if="isRoundRectSupporting" />
  </div>
  <div>
    <img
      src="https://mc.yandex.ru/watch/95432634"
      style="position: absolute; left: -9999px"
      alt=""
    />
  </div>
</template>

<style scoped>
* {
  padding: 0;
  margin: 0;
  overflow: hidden;
}
</style>
